import { API } from './resources'

export default {
  addResource: (data) => {
    return API.post('/partner/resources', data)
  },
  getResourcesByEvent: () => {
    return API.get('/partner/getResources')
  },
  createResourceSection: (data) => {
    return API.post('/partnerResource/section', data)
  },
  getSectionsByPartner: (eventID) => {
    return API.get(`/partnerResource/getSections/${eventID}`)
  },
  getResourcesBySection: (eventID, sectionID) => {
    return API.get(`/partnerResource/getResources/${eventID}/${sectionID}`)
  },
  deleteResourceById: (resourceId) => {
    return API.delete(`/partnerResource/delete/${resourceId}`)
  },
  deleteSectionById: (resourceId) => {
    return API.delete(`/partnerResource/deleteSection/${resourceId}`)
  },
  updateSection: (sectionID, data) => {
    return API.put(`/partnerResource/updateSection/${sectionID}`, data)
  },
  updateResource: (resourceID, data) => {
    return API.put(`/partnerResource/updateResource/${resourceID}`, data)
  }
}
